import React, { Component } from 'react';
import { View, StyleSheet, ScrollView, Button, TouchableOpacity, ImageBackground } from 'react-native';
import { Surface } from 'react-native-paper'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import Timer from './../Timer';
import { changeQuestion } from './../../store/action';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
// import BackHandlerAndroid from './../AndroidBackHandler';
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import StylesColors from './../Colors';
// import OfflineHandler from './../OfflineHandler';
import { Text, Styles} from "./../../components/UI-Components";
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';
// import { useTheme } from '@material-ui/core/styles';
// const theme = useTheme();
//   const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

const unAnswered = require('./../../assets/assets_png/unanswerd.png');
const _answered = require('./../../assets/assets_png/answerd.png');
const _marked = require('./../../assets/assets_png/marked.png');

const box = theme => ({
  dialogPaper: {
  // opacity: 0.5,
  minWidth: 400,
  height: '100vh'
  },
 
  });


function Transition(props) {
  return <Slide direction="down" {...props} />;
}


const IndicatorComponent = ({title, backgroundColor, border}) => (
  <View style={styles.flexRow}>
    <View style={[styles.indicator, {backgroundColor, borderWidth: border ? 0.8 : 0}]}></View>
    <Text style={styles.fontSize}>{title}</Text>
  </View>
)
class SelectedAnswers extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

// static navigationOptions = ({ navigation }) => {
//     return {
//         headerTitle: 'QUESTIONS LIST',
//         headerBackground: 
//         ( <LinearGradientComponent />),
//         headerRight: <View />,
//         headerTintColor:StylesColors.headerTintColor,
//         headerTitleStyle: {
//             color:StylesColors.headerTextColor,
//             alignItems:'center',
//             alignSelf: 'center',
//             textAlign: 'center',
//             flexGrow: 1, 
//             fontWeight:StylesColors.headerTextFontWeight
//         },
//     }
// }


  render() {
    const { classes } = this.props;
    return (
      <div 
      // className='main-component'
      
      >
          <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          
          PaperProps={{ classes: {root: classes.dialogPaper } }}

        >
         <List
         
          className='select-question-box'
         >
            <ListItem button style={{display: 'flex', justifyContent:'space-between', alignItems:'center',height: 50,
                backgroundColor: Styles.primaryColor,
                color: '#fff',
                paddingTop:11,
                fontSize: 16,
                fontWeight:400}} disableRipple>
            <IconButton color="inherit" 
            onClick={this.props.handleClose} 
            aria-label="Close">
                <CloseIcon />             
            </IconButton>
            <div>
              Select Questions
            </div>
              {/* <div className="pt-1">
                {this.props.contentHeader}                  
              </div> */}
              {/* <div style={{display: 'flex', justifyContent:'center', alignItems:'center',
                height: 50,
                backgroundColor:'blue',
                color: '#fff',
                paddingTop:11,
                fontSize: 16,
                fontWeight:400
            }}>             
              
                 
                  <MultipleContentSelectComponent allContentData={this.props.allContentData} data={this.props.data} content={this.state.content} textField={classes.textField} handleChange={this.handleChange}/>
                
              </div> */}
            </ListItem>
          </List>      
      
      {/* <BackHandlerAndroid goBack={true}/> */}
      {/* <OfflineHandler /> */}
      <View style={{flex:1,paddingVertical:30,borderRadius:10, marginHorizontal: 10}}>
          <View style={{paddingHorizontal:20, padding: 20, borderRadius:10,paddingBottom:20, height: "100%"}}>
     
        <View style={styles.headerCom}>
              <Text style={styles.headerText}>Question Map</Text>
        </View>
        <View style={{
            flexDirection: 'column',
            marginHorizontal: 15,
            marginBottom: 10,
            marginTop: 10,
            justifyContent: 'flex-start',
            // alignItems: 'center'
          }}>
        {/* <View style={{marginTop:20}}>
            <Text style={{fontSize:16, fontWeight:'600'}}>QUESTION LIST</Text>            
        </View> */}
          <IndicatorComponent title="UNANSWERED" backgroundColor={'#F6F6F6'} border/>
          <IndicatorComponent title="ANSWERED" backgroundColor={Styles.green} />
          <IndicatorComponent title="MARKED" backgroundColor={Styles.fiveMantraBgColor} />         
        </View>
        <View style={{ paddingVertical: 20, borderRadius: 10, marginHorizontal: 15 }}>
        {/* <View style={{
              borderRadius: 10, paddingBottom: 20,
              height: '75%', backgroundColor: 'transparent',
              borderRadius: 10, borderWidth: 3, borderColor: '#fff'
            }}> */}
            <ScrollView
                style={{
                  flex: 1,
                  paddingBottom: 20,
                  paddingVertical: 10,
                  paddingHorizontal: 20,
                }}
            >
            <View style={styles.mainContainer}>
            {
              this.props.questions && this.props.questions.length > 0 && this.props.questions.map((data, index) => {
                  let marked, answered, bgColor, color='#000'; 
                  let borderWidth = 0;           
                  this.props.questionsInfo.map(qi => {
                    if(data.id === qi.id) {
                        if(qi['marked']) return marked = true;
                    }                 
                  })
                  this.props.selectedAnswers.map((sa, index) => {
                    if(data.id === sa.id) return answered = true;
                  })

                  bgColor = unAnswered; color='#707070';

                  if(marked) {            
                    bgColor = _marked
                    color = '#000'
                  }
                  if(answered && !marked) {
                    bgColor = _answered;
                    color='steelblue'
                  }
                
                  // marked 
                  // ? (bgColor = Styles.red, color=Styles.white)
                  // : (answered && !marked)
                  // ? (bgColor = Styles.green, color=Styles.white)
                  // : (bgColor = '#F6F6F6', color='#707070', borderWidth=0.8)         
                  // console.log(marked, answered, bgColor, color, 'show selected')
                  return(
                    <ImageBackground source={bgColor}
                        style={{ width: 54, height: 54, justifyContent: 'center', alignItems: 'center' }}
                    >
                        <TouchableOpacity 
                          style={[styles.qustionWrapper, { backgroundColor:bgColor, borderWidth}]}
                          onPress={ () => {
                            this.props.changeQuestion(index, this.props.activeQuestionId);
                            this.props.handleClose()
                            // this.props.history.goBack();
                          } }
                          key={index}
                        >
                          <Text style={{color}}>{index + 1}</Text>               
                        </TouchableOpacity>
                    </ImageBackground>
                  )
              })
            }
            </View>
            </ScrollView>
          {/* </View>     */}
        </View>
         </View>
        </View>
       </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => ({
    questions: state.testInfo.test,
    questionsInfo: state.testInfo.questionsInfo,
    selectedAnswers: state.testInfo.selectedAnswers ?  state.testInfo.selectedAnswers : [] 
})

const styles = StyleSheet.create({
  main: {
    flex: 1,
    backgroundColor: Styles.fiveMantraBgColor
  },
  headerCom: {
    // flex: 1,
    marginHorizontal: 15,
    marginBottom: 10
  },
  headerText: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  indicator: {
    height: 18,
    width: 18,
    borderWidth: 3,
    borderColor: '#fff',
    marginRight: 6,
    borderRadius: 100,
    // marginBottom: 10
  },
  flexRow: {
    flexDirection: 'row',
    alignItems: 'center',
    // alignItems: 'center'
    // justifyContent:'space-between',
    marginBottom: 10,
  },
  fontSize: {
    fontSize: 12
  },
  mainContainer: {
    // flex:1,
    // backgroundColor: '#fff',
    flexDirection: 'row',
    flexWrap: 'wrap',
    // marginHorizontal:'auto',
    paddingHorizontal: 25,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  qustionWrapper: {
    borderColor: '#ccc',
    width: 50,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 8,
    borderRadius: 25
  },

})


export default connect(mapStateToProps, {changeQuestion})(withStyles(box, {withTheme: true})(withRouter(SelectedAnswers)));
